import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[qcId]'
})
export class QcIdDirective {
  @Input() qcId: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.qcId) {
      this.el.nativeElement.setAttribute('qcId', this.qcId);
    }
  }
}
